module.exports = __webpack_public_path__ + "static/media/avatar_erik_akerfeldt.9e5be049.jpg";